import request from '@/utils/request';

export function dashboardApi() {
    return {
        // 用户统计
        userCollectList: params => {
            return request({
                url: '/admin/index/user_collect_all',
                method: 'get',
                params,
            });
        },
        // 充值统计
        orderCollectList: params => {
            return request({
                url: '/admin/index/order_collect_all',
                method: 'get',
                params,
            });
        },
        // 图表
        indexChart: day => {
            return request({
                url: `/admin/index/chart?days_ago=${day}`,
                method: 'get'
            });
        },
        // 今日/昨日排行
        moviesCollectRank: params => {
            return request({
                url: `/admin/index/movies_collect_rankings`,
                method: 'get',
                params
            });
        },
        // 今日/昨日排行
        moviesCollectRankingsList: params => {
            return request({
                url: `/admin/index/movies_collect_rankings_list`,
                method: 'get',
                params
            });
        },
    };
}
